'use strict';

import angular from 'angular';

export default angular
  .module('app.modalHeader', [])
  .directive('modalHeader', () => {
    return {
      restrict: 'E',
      replace: true,
      template: require('./modal-header.html')
    };
  }).name;
